import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Teleport as _Teleport, createBlock as _createBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/logo_iacd.png'


const _hoisted_1 = {
  class: "card border-0 rounded-0 bg-white authentication-card",
  style: {"margin-top":"20% !important","border-radius":"15px !important","width":"500px","max-width":"95%"}
}
const _hoisted_2 = {
  class: "card-body letter-spacing",
  style: {"padding":"45px 50px !important"}
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_4 = { class: "fw-medium" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_6 = { class: "fw-medium" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = {
  key: 0,
  class: "my-ultimate-otp-modal"
}
const _hoisted_10 = { class: "my-ultimate-otp-card" }
const _hoisted_11 = { class: "body p-4" }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_13 = { class: "fw-medium" }
const _hoisted_14 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_15 = { class: "fw-medium" }
const _hoisted_16 = { class: "mb-4" }
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = {
  key: 0,
  class: "my-ultimate-otp-modal"
}
const _hoisted_20 = { class: "my-ultimate-otp-card" }
const _hoisted_21 = { class: "header" }
const _hoisted_22 = { class: "body" }
const _hoisted_23 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_24 = { class: "fw-medium" }
const _hoisted_25 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center mb-4 rounded-3",
  role: "alert"
}
const _hoisted_26 = { class: "fw-medium" }
const _hoisted_27 = { class: "footer" }
const _hoisted_28 = ["disabled"]

import { ref, onMounted, nextTick, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { useRoute, useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import JwtService from "@/services/JwtService";
import { useAuthStore } from '@/services/auth';
import Swal from "sweetalert2";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();
const globalError = ref<string | null>(null);
const globalSuccess = ref<string | null>(null);
const showChangePasswordForm = ref(false);
const showOtpModal = ref(false);
const otp = ref("");
const loginUserId = ref<number | null>(null); // stocke userId renvoyé par le backend

const firstLoginUserId = ref<string | null>(null);
watch(
  () => route.path,
  (path) => {
    if (path === "/login" || path === "/") {
      nextTick(() => {
        const email = document.querySelector('input[name="email"]') as HTMLInputElement;
        const password = document.querySelector('input[name="password"]') as HTMLInputElement;
        if (email) email.value = "";
        if (password) password.value = "";
      });
    }
  },
  { immediate: true }
);
const loginSchema = Yup.object({
  email: Yup.string().email("Email invalide").required("Email requis"),
  password: Yup.string().required("Mot de passe requis"),
});
// Schema : ancien mot de passe obligatoire lors de la première connexion
const changePasswordSchema = Yup.object({
  oldPassword: Yup.string().required("Ancien mot de passe requis"),
  newPassword: Yup.string()
    .min(8, "Minimum 8 caractères")
    .required("Nouveau mot de passe requis"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("newPassword")], "Les mots de passe ne correspondent pas")
    .required("Confirmation requise"),
});

// Login
const onSubmitLogin = async (values: any) => {
  globalError.value = null;
  globalSuccess.value = null;
  try {
    // const res = await ApiService.post("/loginUser", {
    //   email: values.email.toLowerCase().trim(),
    //   password: values.password,
    // });

    // const data = res.data;
    // if (data.firstLogin === true) {
    //   JwtService.saveToken(data.token);
    //   ApiService.vueInstance.axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    //   firstLoginUserId.value = data.userId;
    //   showChangePasswordForm.value = true;
    //   globalSuccess.value = "Première connexion détectée. Veuillez changer votre mot de passe.";
    // } else {
    //   JwtService.saveToken(data.token);
    //   ApiService.vueInstance.axios.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    //   loginUserId.value = data.user.id;
    //   showOtpModal.value = true;
    //   globalSuccess.value = "Un code de vérification a été envoyé sur votre email";
    //   return;
    // }
    router.push({ name: "tableauBordPage" });
  } catch (err: any) {
    globalError.value = err.response?.data?.message || "Identifiants incorrects";
  }
  // console.log("Login values:", values)
  //            router.push({ name: "tableauBordPage" });
};

// Changement mot de passe
const handleChangePassword = async (values: any) => {
  globalError.value = "";
  try {
    await ApiService.put(`/user/${firstLoginUserId.value}`, {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
    });
    globalSuccess.value = "Mot de passe modifié avec succès ! Connectez-vous maintenant avec votre nouveau mot de passe.";
    setTimeout(() => {
      // Nettoyage complet
      JwtService.destroyToken();
      delete ApiService.vueInstance.axios.defaults.headers.common["Authorization"];
      showChangePasswordForm.value = false;
      globalSuccess.value = "";
      globalError.value = "";
      router.push("/login");
    }, 2500); // 2.5 secondes pour lire le message

  } catch (err: any) {
    globalError.value = err.response?.data?.message || "Erreur lors du changement";
  }
};

const logoutAndRedirect = () => {
  JwtService.destroyToken();
  delete ApiService.vueInstance.axios.defaults.headers.common["Authorization"];

  showChangePasswordForm.value = false;
  // On vide les messages
  globalSuccess.value = "";
  globalError.value = "";
  nextTick(() => {
    const emailInput = document.querySelector('input[name="email"]') as HTMLInputElement;
    emailInput?.focus();
  });
};

const verifyOtpLogin = async () => {
  if (!loginUserId.value || otp.value.length !== 6) {
    globalError.value = "Veuillez saisir 6 chiffres";
    return;
  }
  try {
    const response = await ApiService.post("/verifyOtp", {
      userId: loginUserId.value,
      otp: otp.value.trim(),
      purpose: "login"
    });

    if (response.data.code === 200 || response.data.success) {
      const data = response.data.data || response.data;

      // Stockage des tokens
      localStorage.setItem("authToken", data.token || data.accessToken);
      localStorage.setItem("refreshToken", data.refreshToken || "");

      // Connexion dans le store
      const authStore = useAuthStore();
      authStore.login(data.user);
      const nomComplet = data.user.nom
        ? `${data.user.nom} ${data.user.prenom || ''}`.trim()
        : data.user.prenom || data.user.email;

      globalSuccess.value = `Connexion réussie ! Bienvenue ${nomComplet} !`;
      showOtpModal.value = false;
      otp.value = "";

      // Redirection
      setTimeout(() => {
        router.push({ name: "tableauBordPage" });
      }, 1500);

    } else {
      globalError.value = response.data.message || "Code OTP incorrect";
      setTimeout(() => {
        router.push({ name: "LoginPage" });
      }, 1500);
    }
  } catch (error: any) {
    globalError.value = error.response?.data?.message || "Code invalide ou expiré";
    console.error("Erreur vérification OTP:", error);
  }

  return {
    verifyOtpLogin,

  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[8] || (_cache[8] = _createElementVNode("img", {
          src: _imports_0,
          alt: "logo",
          class: "mb-10 d-block mx-auto",
          style: {"width":"250px","height":"auto"}
        }, null, -1)),
        _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, " Veuillez vous connecter ", -1)),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (globalSuccess.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-check-circle-fill me-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(globalSuccess.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_Transition, { name: "fade" }, {
          default: _withCtx(() => [
            (globalError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(globalError.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(Form), {
          onSubmit: onSubmitLogin,
          "validation-schema": _unref(loginSchema)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Email", -1)),
              _createVNode(_unref(Field), {
                name: "email",
                type: "email",
                class: "form-control form-control-lg text-black",
                style: {"height":"50px","font-size":"1rem"},
                placeholder: "example@email.com"
              }),
              _createVNode(_unref(ErrorMessage), {
                name: "email",
                class: "text-danger small"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Mot de passe", -1)),
              _createVNode(_unref(Field), {
                name: "password",
                type: "password",
                class: "form-control form-control-lg text-black",
                style: {"height":"50px","font-size":"1rem"},
                placeholder: "Entrez votre mot de passe"
              }),
              _createVNode(_unref(ErrorMessage), {
                name: "password",
                class: "text-danger small"
              })
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("button", {
              type: "submit",
              class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 bg-primary d-block w-100 py-3"
            }, " Se connecter ", -1))
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showChangePasswordForm.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", { class: "header text-center position-relative py-4 bg-light" }, [
                _cache[10] || (_cache[10] = _createElementVNode("h5", {
                  class: "mb-0 fw-bold",
                  style: {"text-align":"center !important"}
                }, "Première connexion", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close position-absolute end-0 top-50 translate-middle-y me-4",
                  onClick: logoutAndRedirect,
                  "aria-label": "Fermer"
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (globalSuccess.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _cache[11] || (_cache[11] = _createElementVNode("i", { class: "bi bi-check-circle-fill me-2" }, null, -1)),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(globalSuccess.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (globalError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(globalError.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Form), {
                  onSubmit: handleChangePassword,
                  "validation-schema": _unref(changePasswordSchema)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "form-label fw-semibold text-start" }, "Ancien mot de passe", -1)),
                      _createVNode(_unref(Field), {
                        name: "oldPassword",
                        type: "password",
                        class: "form-control",
                        placeholder: "Saisissez votre ancien mot de passe"
                      }),
                      _createVNode(_unref(ErrorMessage), {
                        name: "oldPassword",
                        class: "text-danger small"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label fw-semibold text-start" }, "Nouveau mot de passe", -1)),
                      _createVNode(_unref(Field), {
                        name: "newPassword",
                        type: "password",
                        class: "form-control",
                        placeholder: "Minimum 8 caractères"
                      }),
                      _createVNode(_unref(ErrorMessage), {
                        name: "newPassword",
                        class: "text-danger small"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label fw-semibold text-start" }, "Confirmer le nouveau mot de passe", -1)),
                      _createVNode(_unref(Field), {
                        name: "confirm_password",
                        type: "password",
                        class: "form-control",
                        placeholder: "Retaper le nouveau"
                      }),
                      _createVNode(_unref(ErrorMessage), {
                        name: "confirm_password",
                        class: "text-danger small"
                      })
                    ]),
                    _createElementVNode("div", { class: "d-flex gap-3" }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary flex-fill",
                        onClick: logoutAndRedirect
                      }, " Annuler "),
                      _cache[16] || (_cache[16] = _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary flex-fill"
                      }, " Modifier ", -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showOtpModal.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "text-center" }, "Vérification en deux étapes", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (showOtpModal.value = false))
                })
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-muted small mb-3" }, "Entrez le code à 6 chiffres reçu par email", -1)),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (globalSuccess.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _cache[18] || (_cache[18] = _createElementVNode("i", { class: "bi bi-check-circle-fill me-2" }, null, -1)),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(globalSuccess.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    (globalError.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _cache[19] || (_cache[19] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(globalError.value), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((otp).value = $event)),
                  type: "text",
                  inputmode: "numeric",
                  maxlength: "6",
                  class: "form-control form-control-lg text-center",
                  onKeyup: _withKeys(verifyOtpLogin, ["enter"]),
                  autofocus: ""
                }, null, 544), [
                  [_vModelText, otp.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  class: "btn btn-outline-secondary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showOtpModal.value = false))
                }, " Annuler "),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: verifyOtpLogin,
                  disabled: otp.value.length !== 6
                }, " Valider ", 8, _hoisted_28)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})